import { SLOT_LABEL_LINE_EXPORT_HEADERS } from "./slotLabelsCsvExport";

const NEEDS_QUOTING = /[",\n\r]/;

function escapeCell(value: unknown): string {
  if (value === null || value === undefined) return "";
  const s = typeof value === "string" ? value : String(value);
  if (!NEEDS_QUOTING.test(s)) return s;
  return `"${s.replace(/"/g, '""')}"`;
}

function rowsToCsv(headers: readonly string[], rows: Array<Array<unknown>>): string {
  const lines = [headers.join(",")];
  for (const row of rows) {
    lines.push(row.map(escapeCell).join(","));
  }
  return lines.join("\n") + "\n";
}

/** Starter CSV for slot-label line assignment bulk import. */
export const EXAMPLE_SLOT_LABELS_BULK_IMPORT_CSV = rowsToCsv(SLOT_LABEL_LINE_EXPORT_HEADERS, [
  ["", "BASE_16", "2X6_16", "2x6x16 SPF", 4, "wall_stud"],
  ["", "BASE_16", "OSB_716", "OSB 7/16", 12, "wall_sheathing"],
  ["", "ROOF_A", "TRUSS_24", "24in truss", 1, "roof_truss"],
]);
